import { IonCol } from '@ionic/react';
import React from 'react';
import { DistanceFromLocation } from '../../components/DistanceFromLocation';
import * as commonCss from '../../styles/common';
import { BaseSection } from '../BaseSection';

export interface DistanceFromLocationSectionProps {
  onClose: () => void;
}

export const DistanceFromLocationSection: React.FC<DistanceFromLocationSectionProps> = ({ onClose }) => {
  return (
    <BaseSection compact>
      <IonCol css={commonCss.noPadding}>
        <DistanceFromLocation onClose={onClose} />
      </IonCol>
    </BaseSection>
  );
};
